<template>
  <div class="run-left-main">
    <ul class="list-data list-data-run-list no-links m-t-none">
      <li class="data-heading sticky">
        <div class="row">
          <div class="col-xs-1">&nbsp;</div>
          <div class="col-xs-5">Label Type</div>
          <div class="col-xs-2">
            <p class="text-truncate"></p>
          </div>
          <div class="col-xs-2">
            <p class="text-truncate"></p>
          </div>
          <div class="col-xs-4"></div>
        </div>
        <!-- /.row -->
      </li>

      <print-label
        v-for="label in labels"
        :key="label.id"
        :label="label"
        @handleSelect="handleClick"
      />
    </ul>
    <!-- /.list-data -->
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PrintLabel from './Label'

export default {
  components: {
    PrintLabel
  },

  computed: {
    ...mapState('printLogs', ['labels'])
  },

  methods: {
    handleClick (item) {
      this.$emit('labelClicked', item)
    }
  }
}
</script>
